export const PageText = {
  _1: 'Pers',
  _2: 'Op deze pagina vindt U allerhande persmateriaal over aircheckr terug. Als er nog iets ontbreekt, neem dan gerust <a href="/contact">contact</a> met ons op.'
};

export const Categories = {
  _1: {
    title: 'aircheckr',
    subcategories: [
      {
        key: 0,
        text: 'Luchtvervuiling veroorzaakt jaarlijks 467.000 doden in Europa. Niet zo lang geleden was de vervuilde lucht nog een onderschatte stille moordenaar. Vandaag wordt het beschouwd als het grootste omgeving gerelateerde gezondheidsrisico voor de mens. Maar er is hoop. Wetenschappelijk onderzoek heeft aangetoond dat het verminderen van blootstelling aan luchtvervuiling effectief helpt. Maar hoe moet men dat doen? aircheckr biedt gedetailleerde buitenluchtkwaliteit informatie en tools die nodig zijn om de blootstelling effectief te verminderen. Het stelt mensen in staat om actief of passief betere beslissingen en acties te nemen om betere lucht in te ademen. Mensen zijn niet langer weerloos. Het verbeteren van de lucht binnen in huis / kantoor of auto, of het verminderen van de blootstelling tijdens het fietsen of sporten is nu mogelijk. Samen met haar partners werkt aircheckr hard om luchtkwaliteitsinformatie te integreren in een breed scala aan diensten, applicaties of apparaten.'
      }
    ]
  },
  _2: {
    title: 'Het probleem van luchtkwaliteit',
    subcategories: [
      {
        key: 0,
        text: 'De gevolgen van luchtvervuiling zijn alarmerend. Het beïnvloedt vooral het ademhaling- en cardiovasculaire systeem. Alleen al in België sterft elke uur gemiddeld minstens 1 persoon door luchtvervuiling. Veel mensen zijn bezorgd, maar voelen zich machteloos om zelf iets te doen. Wanneer iemand te veel heeft gedronken en vervolgens iemand aanrijdt met de auto, dan is de oorzaak snel duidelijk, maar met luchtvervuiling is dit niet zo eenduidig. Luchtkwaliteit is erg complex. Er zijn veel verschillende polluenten en hun effect op de gezondheid is niet altijd duidelijk. Bovendien varieert de luchtkwaliteit veel in plaats en tijd. De luchtvervuiling naast een snelweg tijdens de spits kan sterk afwijken van deze in het park slechts 200 meter verderop.'
      }
    ]
  },
  _3: {
    title: 'Goede luchtkwaliteit start met goede luchtkwaliteitsdata',
    subcategories: [
      {
        key: 0,
        text: 'De huidige luchtkwaliteitsgegevens zijn meestal niet geschikt voor individueel gebruik of zakelijke toepassingen. aircheckr verandert dit volledig. De aircheckr algoritmen berekenen de luchtkwaliteitsinformatie tot op het detail van een straat, real-time, maar ook voorspellingen en statistieken zijn mogelijk. De aircheckr Air Quality Index vertaalt de complexiteit aan verschillende polluentconcentraties in een gebruiksvriendelijke en gezondheid gebaseerde getal, label of kleur. Persoonlijke aanbevelingen en tips geven mensen de mogelijkheid om adequate maatregelen te treffen. De luchtkwaliteitsgegevens kunnen eenvoudig in verschillende toepassingen geïntegreerd worden via een uitgebreide API of een widget.',
        text_2: 'aircheckr is ontwikkeld om onze dagelijkse beslissingen positief te beïnvloeden, en zo de gezondheid van iedereen te verbeteren.'
      }
    ]
  },
  _4: {
    title: 'Team',
    subcategories: [
      {
        key: 0,
        text: 'aircheckr is een product van nazka mapps (www.nazka.be) en wordt ondersteund door het Europees Ruimtevaart Agentschap (ESA). Het is ontwikkeld door een enthousiast, multidisciplinair team met ervaring in web development, locatie-gebaseerde diensten en data science.'
      }
    ]
  },
  _5: {
    title: 'aircheckr in de pers',
    subcategories: [
      {
        key: 0,
        text: '<strong>Enkele voorbeelden van artikels over aircheckr:</strong>',
        bulletItems: [
          {
            text: 'Herbeluister een <a href="https://radio1.be/na-de-buienradar-nu-ook-de-aircheckr" target="_blank">interview over aircheckr op Radio1</a> - 18/10/2017.'
          },
          {
            text: '<a href="https://www.bloovi.be/nieuws/detail/deze-start-up-wil-het-maken-zonder-kapitaal-liever-maatschappelijke-impact-dan-veel-geld-binnenhalen" target="_blank">Bloovi over nazka mapps en aircheckr</a> - 12/10/2017.'
          }
        ]
      }
    ]
  },
  _6: {
    title: 'Logos',
    subcategories: [
      {
        key: 0,
        text: '<strong>Volgende logos kun je hier downloaden:</strong>',
        logoBanners: [
          {
            key: 0,
            logoAlt: 'aircheckr logo horizontaal',
            description: ''
          },
          {
            key: 1,
            logoAlt: 'aircheckr logo square',
            description: ''
          },
          {
            key: 2,
            logoAlt: 'aircheckr pictogramme',
            description: ''
          }
        ]
      }
    ]
  },
  _7: {
    title: 'Beeldmateriaal',
    subcategories: [
      {
        key: 0,
        text: '<strong>Voel je vrij om één of meerdere van de volgende afbeeldingen te gebruiken in je artikel:</strong>',
        logoBanners: [
          {
            key: 0,
            logoAlt: 'aircheckr team',
            description: ''
          },
          {
            key: 1,
            logoAlt: 'aircheckr founders',
            description: ''
          },
          {
            key: 2,
            logoAlt: 'aircheckr op mobiele telefoon',
            description: ''
          },
          {
            key: 3,
            logoAlt: 'aircheckr widget',
            description: ''
          },
          {
            key: 4,
            logoAlt: 'variatie in lucht kwaliteit tussen 2 locaties op straat niveau',
            description: ''
          },
          {
            key: 5,
            logoAlt: 'variatie in lucht kwaliteit tussen steden',
            description: ''
          },
          {
            key: 6,
            logoAlt: 'variatie in individuele polluenten in één day',
            description: ''
          }
        ]
      }
    ]
  }
};

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/pers_page.js